var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.isHKlandUser || _vm.isTenant
    ? _c("Collapse", {
        staticClass:
          "green-operation__assessment green-operation__air-conditioning",
        scopedSlots: _vm._u(
          [
            {
              key: "title",
              fn: function () {
                return [
                  _c(
                    "HKLLeftRight",
                    [
                      _c("span", { staticClass: "font-bold" }, [
                        _vm._v(
                          _vm._s(
                            _vm.$t(
                              "tenancy.greenOperation.assessments.airConditioning.title"
                            )
                          )
                        ),
                      ]),
                      _vm._v(" "),
                      !_vm.isEdit && _vm.canViewPoint
                        ? _c("HKLInputPoints", {
                            attrs: { isEdit: false },
                            model: {
                              value: _vm.points,
                              callback: function ($$v) {
                                _vm.points = $$v
                              },
                              expression: "points",
                            },
                          })
                        : _vm._e(),
                    ],
                    1
                  ),
                ]
              },
              proxy: true,
            },
            {
              key: "content",
              fn: function () {
                return [
                  _vm.buildingComfyInstallation && _vm.isHKlandUser
                    ? _c(
                        "div",
                        [
                          _c(
                            "HKLLeftRight",
                            {
                              staticClass: "green-operation__assessment-title",
                            },
                            [
                              _c("div", { staticClass: "font-bold" }, [
                                _vm._v(
                                  "\n          " +
                                    _vm._s(
                                      _vm.$t(
                                        "tenancy.greenOperation.assessments.airConditioning.installationOfComfy"
                                      )
                                    ) +
                                    "\n        "
                                ),
                              ]),
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass:
                                "green-operation__assessment-form row",
                            },
                            [
                              [
                                _c(
                                  "HKLRadioButton",
                                  {
                                    staticClass: "small-6",
                                    attrs: {
                                      disabled: !_vm.isEdit,
                                      value: "since",
                                    },
                                    model: {
                                      value: _vm.installationOfComfy.value,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.installationOfComfy,
                                          "value",
                                          $$v
                                        )
                                      },
                                      expression: "installationOfComfy.value",
                                    },
                                  },
                                  [
                                    !_vm.isEdit
                                      ? [
                                          _vm._v(
                                            "\n              " +
                                              _vm._s(
                                                _vm.$t(
                                                  "tenancy.greenOperation.assessments.airConditioning.installationOfComfyOptionSince",
                                                  [_vm.since]
                                                )
                                              ) +
                                              "\n            "
                                          ),
                                        ]
                                      : [
                                          _c("HKLText", {
                                            staticClass:
                                              "air-conditioning__form-since",
                                            attrs: {
                                              text: _vm.$t(
                                                "tenancy.greenOperation.assessments.airConditioning.installationOfComfyOptionSince",
                                                []
                                              ),
                                            },
                                          }),
                                          _vm._v(" "),
                                          _c("DatePicker", {
                                            attrs: {
                                              calendarButton: true,
                                              calendarButtonIcon:
                                                "fa fa-calendar",
                                            },
                                            model: {
                                              value: _vm.sinceDate,
                                              callback: function ($$v) {
                                                _vm.sinceDate = $$v
                                              },
                                              expression: "sinceDate",
                                            },
                                          }),
                                        ],
                                  ],
                                  2
                                ),
                                _vm._v(" "),
                                _c(
                                  "HKLRadioButton",
                                  {
                                    staticClass: "small-3",
                                    attrs: {
                                      disabled: !_vm.isEdit,
                                      value: "no",
                                    },
                                    model: {
                                      value: _vm.installationOfComfy.value,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.installationOfComfy,
                                          "value",
                                          $$v
                                        )
                                      },
                                      expression: "installationOfComfy.value",
                                    },
                                  },
                                  [
                                    _vm._v(
                                      "\n            " +
                                        _vm._s(_vm.$t("action.no")) +
                                        "\n          "
                                    ),
                                  ]
                                ),
                              ],
                            ],
                            2
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.isHKlandUser
                    ? _c(
                        "div",
                        [
                          _c(
                            "HKLLeftRight",
                            {
                              staticClass: "green-operation__assessment-title",
                            },
                            [
                              _c("div", { staticClass: "font-bold" }, [
                                _vm._v(
                                  "\n          " +
                                    _vm._s(
                                      _vm.$t(
                                        "tenancy.greenOperation.assessments.airConditioning.hoursOfAcOperation"
                                      )
                                    ) +
                                    "\n        "
                                ),
                              ]),
                              _vm._v(" "),
                              _vm.canViewPoint
                                ? _c("HKLInputPoints", {
                                    attrs: { isEdit: _vm.isEdit },
                                    model: {
                                      value: _vm.hoursOfAcOperation.point,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.hoursOfAcOperation,
                                          "point",
                                          $$v
                                        )
                                      },
                                      expression: "hoursOfAcOperation.point",
                                    },
                                  })
                                : _vm._e(),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "green-operation__assessment-form" },
                            [
                              _c(
                                "HKLRadioButton",
                                {
                                  attrs: {
                                    disabled: !_vm.isEdit,
                                    value: "lte4",
                                  },
                                  model: {
                                    value: _vm.hoursOfAcOperation.value,
                                    callback: function ($$v) {
                                      _vm.$set(
                                        _vm.hoursOfAcOperation,
                                        "value",
                                        $$v
                                      )
                                    },
                                    expression: "hoursOfAcOperation.value",
                                  },
                                },
                                [
                                  _vm._v(
                                    "\n          " +
                                      _vm._s(
                                        _vm.$t(
                                          "tenancy.greenOperation.assessments.airConditioning.hoursOfAcOperationOption",
                                          ["≤4"]
                                        )
                                      ) +
                                      "\n        "
                                  ),
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "HKLRadioButton",
                                {
                                  attrs: {
                                    disabled: !_vm.isEdit,
                                    value: "lte6",
                                  },
                                  model: {
                                    value: _vm.hoursOfAcOperation.value,
                                    callback: function ($$v) {
                                      _vm.$set(
                                        _vm.hoursOfAcOperation,
                                        "value",
                                        $$v
                                      )
                                    },
                                    expression: "hoursOfAcOperation.value",
                                  },
                                },
                                [
                                  _vm._v(
                                    "\n          " +
                                      _vm._s(
                                        _vm.$t(
                                          "tenancy.greenOperation.assessments.airConditioning.hoursOfAcOperationOption",
                                          ["≤6"]
                                        )
                                      ) +
                                      "\n        "
                                  ),
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "HKLRadioButton",
                                {
                                  attrs: {
                                    disabled: !_vm.isEdit,
                                    value: "gt6",
                                  },
                                  model: {
                                    value: _vm.hoursOfAcOperation.value,
                                    callback: function ($$v) {
                                      _vm.$set(
                                        _vm.hoursOfAcOperation,
                                        "value",
                                        $$v
                                      )
                                    },
                                    expression: "hoursOfAcOperation.value",
                                  },
                                },
                                [
                                  _vm._v(
                                    "\n          " +
                                      _vm._s(
                                        _vm.$t(
                                          "tenancy.greenOperation.assessments.airConditioning.hoursOfAcOperationOption",
                                          ["＞6"]
                                        )
                                      ) +
                                      "\n        "
                                  ),
                                ]
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.isHKlandUser
                    ? _c(
                        "div",
                        [
                          _c(
                            "HKLLeftRight",
                            {
                              staticClass: "green-operation__assessment-title",
                            },
                            [
                              _c("div", { staticClass: "font-bold" }, [
                                _vm._v(
                                  "\n          " +
                                    _vm._s(
                                      _vm.$t(
                                        "tenancy.greenOperation.assessments.airConditioning.averageIndoorTemperatureSetpoint"
                                      )
                                    ) +
                                    "\n        "
                                ),
                              ]),
                              _vm._v(" "),
                              _vm.canViewPoint
                                ? _c("HKLInputPoints", {
                                    attrs: { isEdit: _vm.isEdit },
                                    model: {
                                      value:
                                        _vm.averageIndoorTemperatureSetpoint
                                          .point,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.averageIndoorTemperatureSetpoint,
                                          "point",
                                          $$v
                                        )
                                      },
                                      expression:
                                        "averageIndoorTemperatureSetpoint.point",
                                    },
                                  })
                                : _vm._e(),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass:
                                "green-operation__assessment-form row",
                            },
                            [
                              _c(
                                "HKLRadioButton",
                                {
                                  staticClass: "small-4",
                                  attrs: {
                                    disabled: !_vm.isEdit,
                                    value: "gte23.5",
                                  },
                                  model: {
                                    value:
                                      _vm.averageIndoorTemperatureSetpoint
                                        .value,
                                    callback: function ($$v) {
                                      _vm.$set(
                                        _vm.averageIndoorTemperatureSetpoint,
                                        "value",
                                        $$v
                                      )
                                    },
                                    expression:
                                      "averageIndoorTemperatureSetpoint.value",
                                  },
                                },
                                [_vm._v("\n          ≥23.5℃\n        ")]
                              ),
                              _vm._v(" "),
                              _c(
                                "HKLRadioButton",
                                {
                                  staticClass: "small-4",
                                  attrs: {
                                    disabled: !_vm.isEdit,
                                    value: "23.0-23.4",
                                  },
                                  model: {
                                    value:
                                      _vm.averageIndoorTemperatureSetpoint
                                        .value,
                                    callback: function ($$v) {
                                      _vm.$set(
                                        _vm.averageIndoorTemperatureSetpoint,
                                        "value",
                                        $$v
                                      )
                                    },
                                    expression:
                                      "averageIndoorTemperatureSetpoint.value",
                                  },
                                },
                                [_vm._v("\n          23.0-23.4℃\n        ")]
                              ),
                              _vm._v(" "),
                              _c(
                                "HKLRadioButton",
                                {
                                  staticClass: "small-4",
                                  attrs: {
                                    disabled: !_vm.isEdit,
                                    value: "22.5-22.9",
                                  },
                                  model: {
                                    value:
                                      _vm.averageIndoorTemperatureSetpoint
                                        .value,
                                    callback: function ($$v) {
                                      _vm.$set(
                                        _vm.averageIndoorTemperatureSetpoint,
                                        "value",
                                        $$v
                                      )
                                    },
                                    expression:
                                      "averageIndoorTemperatureSetpoint.value",
                                  },
                                },
                                [_vm._v("\n          22.5-22.9℃\n        ")]
                              ),
                              _vm._v(" "),
                              _c(
                                "HKLRadioButton",
                                {
                                  staticClass: "small-4",
                                  attrs: {
                                    disabled: !_vm.isEdit,
                                    value: "22.0-22.4",
                                  },
                                  model: {
                                    value:
                                      _vm.averageIndoorTemperatureSetpoint
                                        .value,
                                    callback: function ($$v) {
                                      _vm.$set(
                                        _vm.averageIndoorTemperatureSetpoint,
                                        "value",
                                        $$v
                                      )
                                    },
                                    expression:
                                      "averageIndoorTemperatureSetpoint.value",
                                  },
                                },
                                [_vm._v("\n          22.0-22.4℃\n        ")]
                              ),
                              _vm._v(" "),
                              _c(
                                "HKLRadioButton",
                                {
                                  staticClass: "small-4",
                                  attrs: {
                                    disabled: !_vm.isEdit,
                                    value: "lt22.0",
                                  },
                                  model: {
                                    value:
                                      _vm.averageIndoorTemperatureSetpoint
                                        .value,
                                    callback: function ($$v) {
                                      _vm.$set(
                                        _vm.averageIndoorTemperatureSetpoint,
                                        "value",
                                        $$v
                                      )
                                    },
                                    expression:
                                      "averageIndoorTemperatureSetpoint.value",
                                  },
                                },
                                [_vm._v("\n          ＜22.0℃\n        ")]
                              ),
                              _vm._v(" "),
                              _c(
                                "HKLRadioButton",
                                {
                                  staticClass: "small-4",
                                  attrs: { disabled: !_vm.isEdit, value: "na" },
                                  model: {
                                    value:
                                      _vm.averageIndoorTemperatureSetpoint
                                        .value,
                                    callback: function ($$v) {
                                      _vm.$set(
                                        _vm.averageIndoorTemperatureSetpoint,
                                        "value",
                                        $$v
                                      )
                                    },
                                    expression:
                                      "averageIndoorTemperatureSetpoint.value",
                                  },
                                },
                                [
                                  _vm._v(
                                    "\n          " +
                                      _vm._s(_vm.$t("na")) +
                                      "\n        "
                                  ),
                                ]
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.isTenant
                    ? _vm._l(_vm.airConditionForTenant, function (ref, index) {
                        var title = ref.title
                        var value = ref.value
                        var enabled = ref.enabled
                        return enabled
                          ? _c("div", { key: index }, [
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "green-operation__assessment-title",
                                },
                                [
                                  _c("div", { staticClass: "font-bold" }, [
                                    _vm._v(
                                      "\n            " +
                                        _vm._s(title) +
                                        "\n          "
                                    ),
                                  ]),
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "green-operation__assessment-form row",
                                },
                                [
                                  _vm._v(
                                    "\n          " +
                                      _vm._s(value) +
                                      "\n        "
                                  ),
                                ]
                              ),
                            ])
                          : _vm._e()
                      })
                    : _vm._e(),
                ]
              },
              proxy: true,
            },
          ],
          null,
          false,
          2775772899
        ),
      })
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }